import React from 'react';
import './PrivacyModal.css';

function PrivacyModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="privacy-modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 1 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"/>
          </svg>
        </button>

        <h2>Privacy Policy</h2>
        <p className="privacy-meta">Crackle &nbsp;·&nbsp; Effective date: June 4, 2026 &nbsp;·&nbsp; Developer: The AI Whisperer</p>

        <p>This privacy policy describes how Crackle ("the app", "we", "us") handles information when you play the game. We have designed Crackle to be privacy-friendly by default: we do not collect your name, email address, phone number, location, or any other personally identifiable information.</p>

        <hr className="privacy-divider" />

        <h3>What we collect</h3>
        <p>When you play Crackle, the app records anonymous gameplay data including:</p>
        <ul>
          <li>A randomly generated player ID, created on your device the first time you launch the app</li>
          <li>The target code for each puzzle</li>
          <li>The number of guesses you made</li>
          <li>Whether you won or lost</li>
          <li>The difficulty level played</li>
        </ul>
        <p>This data is stored both on your device (local storage) and on our servers, hosted by Vercel Inc. The player ID is not linked to your identity in any way.</p>

        <h3>What we do not collect</h3>
        <ul>
          <li>Your name, email address, or contact details</li>
          <li>Your location</li>
          <li>Device identifiers such as advertising IDs</li>
          <li>Any information from your contacts, camera, or microphone</li>
        </ul>

        <h3>How we use the data</h3>
        <p>We use anonymous gameplay data solely to understand engagement, improve puzzle difficulty ratings, and identify bugs. We do not sell, rent, or share your data with third parties for advertising or marketing purposes.</p>

        <h3>Artificial intelligence</h3>
        <p>Puzzle difficulty ratings were generated using AI simulation. No AI processing involves personal information.</p>

        <h3>Data storage and security</h3>
        <p>Gameplay data is stored on servers provided by Vercel Inc., located in the United States. Because no personal information is collected, the privacy risk to you as a player is minimal.</p>

        <h3>Children</h3>
        <p>Crackle is a general-audience game. We do not knowingly collect personal information from anyone, including children under the age of 13.</p>

        <h3>Your rights</h3>
        <p>Because we do not collect personally identifiable information, we are unable to identify or retrieve data belonging to a specific individual. If you have questions, please contact us below.</p>

        <h3>Changes to this policy</h3>
        <p>If we make material changes to this policy, we will update the effective date above and, where appropriate, notify users through the app.</p>

        <h3>Contact</h3>
        <p>
          <strong>The AI Whisperer</strong><br />
          1742011 Ontario Corp.<br />
        </p>
      </div>
    </div>
  );
}

export default PrivacyModal;
